// extracted by mini-css-extract-plugin
module.exports = {"root":"CenteredContent-m__root___dUR7D"};